import { $themeConfig } from '@themeConfig'

export default {
  state: {
    connected: false,
    websocket: null,
    // id пользователя, под которым держим соединение — нужен для авто-reconnect
    userId: null,
    // намеренное закрытие (логаут) — чтобы onclose не переподключался
    manualClose: false,
    play: false,
    // инкремент-токен для сигнала календарю о необходимости обновить события
    calendarRefreshToken: 0,
    // типы уведомлений, которые должны триггерить перезагрузку календаря
    bookingTypes: ['booking_created', 'booking_updated', 'booking_cancelled', 'booking_payment_successful'],
    appTypes: ['mobile_app_purchase_completed', 'mobile_app_access_subscription_created', 'mobile_app_access_subscription_updated', 'mobile_app_access_subscription_cancelled', 'mobile_app_access_subscription_renewed']
  },
  getters: {
    getPlay(state) {
      return state.play
    },
    getCalendarRefreshToken(state) {
      return state.calendarRefreshToken
    },
  },
  mutations: {
    UPDATE_WEBSOCKET(state, data) {
      state.websocket = data
    },
    UPDATE_CONNECTED(state, data) {
      state.connected = data
    },
    UPDATE_WS_USER(state, data) {
      state.userId = data
    },
    UPDATE_WS_MANUAL_CLOSE(state, data) {
      state.manualClose = data
    },
    UPDATE_PLAY(state) {
      state.play = !state.play
    },
    TRIGGER_CALENDAR_REFRESH(state) {
      state.calendarRefreshToken += 1
    },
  },
  actions: {
    // Соединение поднимается один раз на уровне App.vue и живёт через смену
    // layout'ов (account ↔ dashboard) — не завязано на монтирование navbar.
    async connect(context, user) {
      // запомнить пользователя (для авто-reconnect) и снять флаг ручного закрытия
      if (user) context.commit('UPDATE_WS_USER', user)
      context.commit('UPDATE_WS_MANUAL_CLOSE', false)

      const userId = context.state.userId
      if (context.state.connected || !userId) return

      let wsProtocol = 'wss://'
      if (window.location.protocol !== 'https:') {
        wsProtocol = 'ws://'
      }
      const socket = new WebSocket(
        `${wsProtocol}${$themeConfig.app.backendHostname}/ws/notification/?${userId}`,
      )
      context.commit('UPDATE_WEBSOCKET', socket)

      socket.onopen = () => {
        context.commit('UPDATE_CONNECTED', true)
      }
      socket.onmessage = ({ data }) => {
        const notification = JSON.parse(data)
        console.log('NEW_NOTIFICATION', notification)
        // new booking — показать в колокольчике
        if (notification.notification_type === 'booking_created') {
          context.commit('updatePushNotifications', notification, { root: true })
        }
        // обновление календаря при любом изменении записей
        // TODO: когда бэкенд начнёт слать organization_id в notification.data —
        // фильтровать по текущей организации, чтобы не дёргать refetch зря
        if (context.state.bookingTypes.includes(notification.notification_type)) {
          context.commit('TRIGGER_CALENDAR_REFRESH')
        }
        // mobile app / subscriptions
        if (context.state.appTypes.includes(notification.notification_type)) {
          const orgId = context.rootState.organization.organizationSettings.id
          // context.dispatch('updateApplicationInfo', data, { root: true })
          context.dispatch('checkApplicationStatus', orgId, { root: true })
          context.dispatch('fetchOrganizationSettings', orgId, { root: true })
        }
        if (JSON.parse(localStorage.getItem('sound'))) {
          context.commit('UPDATE_PLAY')
        }
      }
      socket.onerror = () => {
        context.commit('UPDATE_CONNECTED', false)
      }
      socket.onclose = () => {
        context.commit('UPDATE_CONNECTED', false)
        // штатное/сетевое закрытие (не логаут) — переподнять соединение,
        // иначе флаг connected никогда не сбросится, а сокет останется мёртвым
        if (!context.state.manualClose) {
          setTimeout(() => context.dispatch('connect'), 3000)
        }
      }
    },
    disconnect(context) {
      context.commit('UPDATE_WS_MANUAL_CLOSE', true)
      context.commit('UPDATE_CONNECTED', false)
      if (context.state.websocket) {
        context.state.websocket.close()
        context.commit('UPDATE_WEBSOCKET', null)
      }
    },
  },
}
